<template>
  <div>
    <div class="input" :class="inputModifiers" :title="errorMessage">
      <label class="input__label" :for="name">
        <div class="input__placeholder" v-if="placeholder">
          {{ placeholder }}<span v-if="required">*</span>
        </div>
        <div class="input__icon" v-if="hasIcon">
          <slot name="icon"></slot>
        </div>
        <input
          class="input__value"
          :style="inputStyleModifiers"
          :tabindex="tabindex"
          :type="type"
          :autocomplete="autocomplete"
          :disabled="disabled"
          :name="name"
          :id="name"
          :required="required"
          :maxlength="maxLength"
          :max="max"
          :min="min"
          :value="modelValue"
          @input="updateValue"
          @blur="handleBlur"
          @focus="handleFocus"
        />
      </label>
      <template v-if="showValidationWithin">
        <div class="input__validation-message" v-if="error">
          {{ errorMessage }}
        </div>
        <div class="input__success-tick" v-if="successTick"></div>
      </template>
    </div>
    <template v-if="!showValidationWithin">
      <div class="input__validation-message input__validation-message--outer" v-if="error">
        {{ errorMessage }}
      </div>
    </template>
  </div>
</template>

<script src="./input.js"></script>
<style src="./input.scss" lang="scss"></style>
